export enum EnSnowflakeColor {
  Violet = '#9747FF',
  White = '#FFFFFF',
}
